import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import CallDetails from './CallDetails';
import CallSuccess from './CallSuccess';
import FindLocalRep from '../LocalRep/FindLocalRep';
import StandardFrontCard from '../SingleAction/SingleActionDetails';

const StartCard = StandardFrontCard('call', { detailsStyles: {height: 'fit-content'} });

const Call = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/call/start"
                            name="CallStart"
                            exact
                            component={StartCard}
                        />
                        <Route
                            path="/call"
                            name="CallDetails"
                            exact
                            component={CallDetails}
                        />
                        <Route
                            path="/call/success"
                            name="CallSuccess"
                            exact
                            component={CallSuccess}
                        />
                        <Route
                            path="/call/findRep"
                            name="CallFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Call;
